/* auth action types */
export const SHOW_WELCOME_PAGE = "SHOW_WELCOME_PAGE";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const HIDE_ERROR_MESSAGE = "HIDE_ERROR_MESSAGE";
export const SHOW_DASHBOARD = "SHOW_DASHBOARD";
export const SHOW_SEND_OTP_PAGE = "SHOW_SEND_OTP_PAGE";
export const SHOW_VERIFY_OTP_PAGE = "SHOW_VERIFY_OTP_PAGE";
export const VERIFY_OTP = "VERIFY_OTP";
export const LOGOUT = "LOGOUT";
export const CLEAR_COMPONENT_KEY = "CLEAR_COMPONENT_KEY";
export const BUSINESS_PROFILE_REGISTRATION = "BUSINESS_PROFILE_REGISTRATION";
export const SHOW_RESET_EMAIL_CONFIRMATION = "SHOW_RESET_EMAIL_CONFIRMATION";
export const CHANGE_BOARDING_STATUS = "CHANGE_BOARDING_STATUS";
export const EMAIL_VERIFIED = "EMAIL_VERIFIED";
export const RESET_PASSWORD_CODE_VERIFIED = "RESET_PASSWORD_CODE_VERIFIED";
export const DRIVER_DASBOARD = "DRIVER_DASBOARD";
export const GET_ACCOUNT_STATUS = "GET_ACCOUNT_STATUS";
export const REDIRECT_URI = "REDIRECT_URI";

//vendor Profile
export const SHOW_BUSINESS_DETAIL_REGISTRATION =
  "SHOW_BUSINESS_DETAIL_REGISTRATION";
export const GET_FACILITIES_MASTER = "GET_FACILITIES_MASTER";
export const GET_GARAGE_PROFILE = "GET_GARAGE_PROFILE";
export const GET_SERVICES = "GET_SERVICES";
export const VENDOR_PROFILE_DETAILS_UPDATED = "VENDOR_PROFILE_DETAIL_UPDATED";
export const ADD_MANUFACTURERS = "ADD_MANUFACTURERS";
export const ADD_GARAGE_SERVICES = "ADD_GARAGE_SERVICES";
export const CHANGE_COVER_IMAGE = "CHANGE_COVER_IMAGE";
export const ADD_GARAGE_IMAGES = "ADD_GARAGE_IMAGES";
export const CHANGE_COMPANY_LOGO = "CHANGE_COMPANY_LOGO";
export const CLEAR_GARAGE_PROFILE_BATCH_ID = "CLEAR_GARAGE_PROFILE_BATCH_ID";
export const CREATE_GARAGE_PROFILE_BATCH_ID = "CREATE_GARAGE_PROFILE_BATCH_ID";
export const UPLOAD_GARAGE_IMAGE_FAILED = "UPLOAD_GARAGE_IMAGE_FAILED";
export const UPLOAD_GARAGE_IMAGE_SUCCESS = "UPLOAD_GARAGE_IMAGE_SUCCESS";
export const DELETE_GARAGE_IMAGE = "DELETE_GARAGE_IMAGE";
export const GET_REVIEWS_AND_RATINGS = "GET_REVIEWS_AND_RATINGS";
export const GET_ALL_SERVICES = "GET_ALL_SERVICES";
export const GET_SERVICES_VENDOR_PROFILE = "GET_SERVICES_VENDOR_PROFILE";
export const GET_VENDOR_REVIEWS_AND_RATINGS = "GET_VENDOR_REVIEWS_AND_RATINGS";
export const UPDATE_COMMENTS_ON_REVIEW = "UPDATE_COMMENTS_ON_REVIEW";
export const DELETE_COMMENTS_ON_REVIEW = "DELETE_COMMENTS_ON_REVIEW";
/* Open jobs */
export const GET_OPEN_JOB_CATEGORIES = "GET_OPEN_JOB_CATEGORIES";
export const GET_OPEN_JOBS_DATA = "GET_OPEN_JOBS_DATA";
export const INCREASE_OPEN_JOBS = "INCREASE_OPEN_JOBS";

/* Job Detailed View */
export const GET_POSTED_JOB_BY_ID = "GET_POSTED_JOB_BY_ID";
export const GET_JOB_SERVICE_STATUSES = "GET_JOB_SERVICE_STATUSES";
export const DECLINE_A_JOB = "DECLINE_A_JOB";
export const UPDATE_JOB_QUOTE_NOTE = "UPDATE_JOB_QUOTE_NOTE";
export const UPDATE_JOB_STATUS = "UPDATE_JOB_STATUS";
export const CHANGE_STATUS_OF_SIDEBAR_COUNT = "CHANGE_STATUS_OF_SIDEBAR_COUNT";
export const UPDATE_NEW_COUNT = "UPDATE_NEW_COUNT";
export const UPDATE_NEW_COUNT_FOR_JOB_ID = "UPDATE_NEW_COUNT_FOR_JOB_ID";
export const SET_SERVICED_KMS = "SET_SERVICED_KMS";
/* Job History */
export const GET_JOB_HISTORY = "GET_JOB_HISTORY";

/* Common */
export const SEARCH_JOBS = "SEARCH_JOBS";
export const GET_AUTO_SUGGESTED_LIST = "GET_AUTO_SUGGESTED_LIST";
export const SEARCH_VENDORS = "SEARCH_VENDORS";
export const AUTO_ACCEPT_JOB = "AUTO_ACCEPT_JOB";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const HIDE_TOAST_MESSAGE = "HIDE_TOAST_MESSAGE";
export const SEND_QUOTE = "SEND_QUOTE";
export const CONFIRM_PAYMENT = "CONFIRM_PAYMENT";
export const GET_JOB_COUNT = "GET_JOB_COUNT";
export const MARK_MESSAGES_AS_READ = "MARK_MESSAGES_AS_READ";
export const MARK_MESSAGES_AS_READ_FROM_DROPDOWN =
  "MARK_MESSAGES_AS_READ_FROM_DROPDOWN";
export const GET_JOB_SCHEDULE = "GET_JOB_SCHEDULE";
export const CAR_MAKE_AND_MODELS = "CAR_MAKE_AND_MODELS";
export const UPDATE_OVERVIEW_WINLOSS = "UPDATE_OVERVIEW_WINLOSS";
export const OPEN_JOBS_FILTER = "OPEN_JOBS_FILTER";
export const TOGGLE_MESSAGE_TAB = "TOGGLE_MESSAGE_TAB";
export const UPDATE_JOB_FOR_THE_DAY = "UPDATE_JOB_FOR_THE_DAY";

/*userAccont Information*/
export const GET_NOTIFICATION_INFO = "GET_NOTIFICATION_INFO";
export const GET_VENDOR_INFO = "GET_VENDOR_INFO";
export const PROFILE_IMAGE_UPDATED = "PROFILE_IMAGE_UPDATED";

/* Notifications */
export const GET_NOTIFICATION_ALERTS = "GET_NOTIFICATION_ALERTS";
export const MARK_NOTIFICATION_AS_READ = "MARK_NOTIFICATION_AS_READ";
export const NOTIFICATION_FROM_SOCKET = "NOTIFICATION_FROM_SOCKET";

/*ManageUser and MyVehicle Info*/
export const MANAGE_USER_INFO = "MANAGE_USER_INFO";
export const MY_VEHICLE_INFO = "MY_VEHICLE_INFO";
export const MY_VEHICLE_POPUP = "MY_VEHICLE_POPUP";
export const MY_MAPS_INFO = "MY_MAPS_INFO";
export const DRIVER_TYPES = "DRIVER_TYPES";
export const VEHICLE_TYPES = "VEHICLE_TYPES";
export const VEHICLE_INFO = "VEHICLE_INFO";
export const LOADER_DISPLAY = "LOADER_DISPLAY";
export const EMERGENCY_LIST = "EMERGENCY_LIST";
export const GET_VENDOR_TAX = "GET_VENDOR_TAX";

/* Dashboard */
export const GET_TOP_LOCATIONS = "GET_TOP_LOCATIONS";
export const GET_TOP_SERVICES = "GET_TOP_SERVICES";
export const GET_JOB_FOR_TODAY = "GET_JOB_FOR_TODAY";
export const GET_JOB_DISTRIBUTION_CHART = "GET_JOB_DISTRIBUTION_CHART";
export const GET_OVERVIEW = "GET_OVERVIEW";
export const GET_STATISTICS = "GET_STATISTICS";
export const UPDATE_OVERVIEW_GRAPHS = "UPDATE_OVERVIEW_GRAPHS";
/* Chat */
export const CREATE_CHAT_ROOM = "CREATE_CHAT_ROOM";
export const JOIN_CHAT_ROOM = "JOIN_CHAT_ROOM";
export const SENT_NEW_MESSAGE = "SENT_NEW_MESSAGE";
export const RECEIVE_NEW_MESSAGE = "RECEIVE_NEW_MESSAGE";
export const GET_ALL_CHATROOMS = "GET_ALL_CHATROOMS";
export const GET_ALL_MESSAGE_OF_CHAT_ROOM = "GET_ALL_MESSAGE_OF_CHAT_ROOM";
export const GET_ALL_UNREAD_MESSAGES = "GET_ALL_UNREAD_MESSAGES";

/*driver Emergency*/
export const GET_DRIVEREMERGENCY_INFO = "GET_DRIVEREMERGENCY_INFO";
export const DRIVER_ACCEPT_FLAG = "DRIVER_ACCEPT_FLAG";
export const DRIVER_OFFLINE_FLAG = "DRIVER_OFFLINE_FLAG";
export const DRIVER_POSITION = "DRIVER_POSITION";
export const NAVIGATION_FLAG = "NAVIGATION_FLAG";
export const LIST_HISTORY = "LIST_HISTORY";
export const LIST_QUEUE = "LIST_QUEUE";
export const DRIVER_STATUS_UPDATE_FLAG = "DRIVER_STATUS_UPDATE_FLAG";

/* Promotional Offer */
export const APPLY_PROMOTIONAL_OFFERS = "APPLY_PROMOTIONAL_OFFERS";



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js